import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import client from '../api/client';

export default function Results() {
  const [results, setResults] = useState(null);
  const [constituencies, setConstituencies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get('/results').then(res => {
      setResults(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));

    client.get('/results/constituencies').then(res => {
      setConstituencies(res.data);
    }).catch(() => {});
  }, []);

  if (loading) return <div className="loading">Loading results...</div>;

  const totalVotes = results?.total_votes || 0;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Election Results</h1>
        <span>Total Votes Cast: <strong>{totalVotes}</strong></span>
      </div>

      <div className="results-list">
        {results?.parties?.map((party, idx) => {
          const percentage = Math.floor((party.vote_count / totalVotes) * 100);
          return (
            <div key={party.id} className="result-card">
              <div className="result-rank">#{idx + 1}</div>
              <div className="result-info">
                <h2>{party.name}</h2>
                <p>{party.symbol} &bull; {party.vote_count} votes</p>
              </div>
              <div className="result-bar-container">
                <div className="result-bar" style={{ width: totalVotes > 0 ? `${percentage}%` : '0%' }} />
                <span className="result-percentage">{percentage}%</span>
              </div>
            </div>
          );
        })}
        {(!results?.parties || results.parties.length === 0) && (
          <div className="card"><p>No results available yet.</p></div>
        )}
      </div>

      {constituencies.length > 0 && (
        <div className="card">
          <h2>Constituency Results</h2>
          <div className="constituency-links">
            {constituencies.map(c => (
              <Link key={c.id} to={`/results/constituency/${c.id}`} className="constituency-link">
                {c.name}
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className="portal-links">
        <Link to="/vote/login" className="btn-secondary">Voter Portal</Link>
        <Link to="/admin/login" className="btn-secondary">Admin Portal</Link>
        <Link to="/party/login" className="btn-secondary">Party Portal</Link>
      </div>
    </div>
  );
}
